import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="font-heading text-xl font-bold text-background-50 hover:text-primary-400 transition-colors duration-200">
                韩漫在线
              </Link>
              <p className="mt-4 text-sm text-background-400 leading-relaxed">
                韩国漫画网站支持韩漫在线免费观看，包含好看的漫画大全，更新频繁体验佳，让您随时随地探索各种故事并享受无限阅读乐趣。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
              <div className="grid grid-cols-2 gap-2">
                {categories.slice(1, 9).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <div className="space-y-3">
                <Link to="/" className="block text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  首页
                </Link>
                <Link to="/about" className="block text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  关于我们
                </Link>
                <Link to="/category/all" className="block text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  全部漫画
                </Link>
                <Link to="/category/romance" className="block text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  恋爱漫画
                </Link>
                <Link to="/category/fantasy" className="block text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  奇幻漫画
                </Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <div className="space-y-3 text-sm text-background-400">
                <p className="flex items-center gap-2">
                  <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                  contact@hanmanonline.com
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
                  北京市朝阳区望京SOHO
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                  周一至周五 9:00-18:00
                </p>
              </div>
            </div>
          </div>

          <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; 2026 韩漫在线. 保留所有权利.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow" aria-label="QQ">
                <i className="ri-qq-line w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}